import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { isTestnet } from "./ethereum-config"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a number to a specified number of decimal places
 * @param value The number to format
 * @param decimals The number of decimal places to show
 * @returns Formatted number as a string
 */
export function formatNumber(value: number | undefined, decimals = 2): string {
  if (value === undefined || value === null) return "N/A"

  // Handle very small numbers
  if (value < 0.01 && value > 0) {
    return "< 0.01"
  }

  return value.toFixed(decimals)
}

/**
 * Returns a random integer between min (inclusive) and max (inclusive).
 * The value is no lower than min (or the nearest integer greater than min
 * if min isn't an integer) and no greater than max (or the nearest integer
 * less than max if max isn't an integer).
 * Using Math.round() will give you a non-uniform distribution!
 */
export function getRandomInt(min: number, max: number): number {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

/**
 * Generate OpenSea URL for a token
 * @param contractAddress The contract address
 * @param tokenId The token ID
 * @param isTestnet Whether to use testnet URL
 * @returns OpenSea URL string
 */
export function getOpenSeaUrl(contractAddress: string, tokenId: number, isTestnetMode?: boolean): string {
  const useTestnet = isTestnetMode ?? isTestnet
  
  if (useTestnet) {
    // OpenSea Testnets (Sepolia)
    return `https://testnets.opensea.io/assets/sepolia/${contractAddress}/${tokenId}`
  } else {
    // OpenSea Mainnet
    return `https://opensea.io/assets/ethereum/${contractAddress}/${tokenId}`
  }
}
